<template>
  <div class="site-footer">
    <div class="sentinel" ref="sentinel"/>
    <div class="main u-dark">
      <div class="extra-info">
        <div>
          <a href="https://github.com/huertatipografica/Alegreya-Sans">Alegreya Sans</a> font by Juan Pablo del Peral.
        </div>
        <div>
          <a href="https://github.com/etunni/Graduate-Variable-Font">Graduate</a> Variable Font by Eduardo Tunni.
        </div>
        <div>
          Rywalka and <a href="https://github.com/hyvyys/Tektur">Tektur</a> fonts by Adam Jagosz.
        </div>
        <div>
          Sample texts from
          <a href="https://github.com/hyvyys/language-data" target="_blank" rel="noopener noreferrer">
            Language-Data.
          </a><br>
          Visit to contribute! ↑
        </div>
      </div>

      <div class="bulletproof-info">
        <div>
          Bulletproof Font&nbsp;Tester
        </div>
        <div>
          © 2021 Adam&nbsp;Jagosz
        </div>
      </div>
    </div>
    <SigmoidContainer sides="left bottom" width="75" class="large light aside" idSeed="footer">
      <a class="github-link" href="https://github.com/hyvyys/Bulletproof" target="_blank" rel="noopener noreferrer">
        <div>
          Bulletproof
          <br />
          on Github
        </div>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:height="'32'" v-bind:width="'32'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
      </a>
    </SigmoidContainer>
  </div>
</template>

<script>
const version = require('@/../package.json').version;

import SigmoidContainer from "@/components/layout/SigmoidContainer.vue";

export default {
  components: { SigmoidContainer },
  data() {
    return {
      version,
    }
  },
  mounted() {
    // this.initObserver(); // disable un-sticky header
  },
  destroyed() {
    this.observer.disconnect();
  },
  methods: {
    initObserver() {
      let options = { threshold: [0, 0.25, 0.5, 0.75, 1] };
      // eslint-disable-next-line no-unused-vars
      let callback = (entries, observer) => {
        entries.forEach(entry => {
          this.updateHeight(entry);
        });
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.sentinel);
    },
    updateHeight(entry) {
      // const height = entry.intersectionRect.height;
      const ratio = entry.intersectionRatio;
      this.$store.commit("updateFooter", { visible: ratio > 0.75, ratio });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
@import "@/scss/super-gradient.scss";

@mixin footer-background() {
  background: $accent;
  @include gradient-red-2(0.1, 0.045);
  background-size: 100% 150px;
  background-position: 0 100%;
}

.site-footer {
  position: relative;
  font-size: 0.9rem;
  .sentinel {
    position: absolute;
    bottom: 100%;
    height: $footer-height;
    width: 100%;
    pointer-events: none;
  }

  display: flex;
  height: $footer-height;
  justify-items: space-between;
  padding-bottom: 8px;
  @include footer-background();

  .main {
    color: rgba($accent-text, 0.7);
    flex: 1;
    padding: 15px 0px 10px 20px;
    display: flex;
    align-items: center;
    > :not(:last-child) {
      margin-right: 2em;
    }
  }

  .bulletproof-info {
  }

  .light {
    background: $light;
  }
  .aside {
    align-self: stretch;
    padding-right: 14px;
    background: $light;

    .github-link {
      text-decoration: none;
      line-height: 1;
      padding: 0;
      flex: 1;
      overflow: visible;
      display: flex;
      align-items: center;
      margin-left: -1rem;
      div {
        min-width: 70px;
        margin: 0.4em;
        text-align: right;
      }
      svg {
        margin: 0;
      }
    }
  }
}

.extra-info {
  @media (max-width: 600px) {
    display: none;
  }
}
</style>
